const setProvince = (id = null, val = null) => {
  return {
    type: 'SET_PROVINCE',
    id,
    data: val,
  }
}

const setDistrict = (id = null, val = null) => {
  return {
    type: 'SET_DISTRICT',
    id,
    data: val,
  }
}

const setSubDistrict = (id = null, val = null) => {
  return {
    type: 'SET_SUBDISTRICT',
    id,
    data: val,
  }
}

const setZipcode = (val = null) => {
  return {
    type: 'SET_ZIPCODE',
    data: val,
  }
}

export default {
  setProvince,
  setDistrict,
  setSubDistrict,
  setZipcode
}
